'use strict';

var MarketKpiRibbonFilterFactory = function MarketKpiRibbonFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketProductGroupDateRangeFilterFactory', 'MarketProductGroupMarketFilterFactory', 'MarketProductGroupSeasonFilterFactory', 'MarketProductGroupDowFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function KpiRibbonFilter() {
    DemandFilter.call(this, 'market', 'kpi-ribbon');
    this.registerFilters(injectedFilters);
  }
  KpiRibbonFilter.constructor = KpiRibbonFilter;
  KpiRibbonFilter.prototype = Object.create(DemandFilter.prototype);
  return KpiRibbonFilter;
};
MarketKpiRibbonFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = MarketKpiRibbonFilterFactory;